<div class="client-corner-project-info" [ngClass]="displayClass">
  <div
    *ngIf="!alwaysDisplay"
    class="clickable back-button icon-circle"
    (click)="clickBack()"
  >
    <mat-icon class="scale-icon">keyboard_backspace</mat-icon>
  </div>

  <img
    width="372px"
    height="219px"
    class="clickable w-100"
    [src]="latestProjectAssetUrl"
    (click)="openLightbox()"
  />

  <div class="pop-up-padding">
    <div class="d-flex justify-content-between">
      <div class="d-flex">
        <div class="project-title clickable" (click)="openProject()">
          Opdracht #{{ project.id }}
          <ng-container
            *ngIf="
              latestSubProject?.type === 'BaseProject' &&
              latestSubProject?.clientDisplayStatus === 'Nieuw'
            "
          >
            (Nieuw)
          </ng-container>
        </div>
      </div>

      <ng-container
        *ngIf="
          latestSubProject?.clientDisplayStatus !== 'Nieuw' &&
          latestSubProject?.clientDisplayStatus !== 'In behandeling'
        "
      >
        <div class="ml-auto pr-2">
          <a *ngIf="mailContent?.length > 0" href="{{ mailContent }}">
            <mat-icon class="icon-xxl">mail</mat-icon>
          </a>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="pop-up-padding-first">
    <div
      *ngFor="let product of project.products; trackBy: trackById"
      class="d-flex"
    >
      <p class="font-weight-bold mb-0">{{ product.displayType }} -&nbsp;</p>

      <p class="font-weight-bold mb-0">{{ product.size }}&nbsp;</p>

      <p class="font-weight-bold mb-0">- {{ product.clientCornerTitle }}</p>
    </div>

    <div>
      <p>
        {{
          latestSubProject?.projectPlacement?.address?.line1
            | printAddress
              : latestSubProject?.projectPlacement?.address?.postalCode
              : latestSubProject?.projectPlacement?.address?.city
        }}
      </p>
    </div>
  </div>
  <div
    *ngIf="
      latestSubProject?.type == 'BaseProject' && productTypeDisplays?.length > 0
    "
    class="pop-up-padding-first d-flex"
  >
    <p>Type:</p>

    <div class="ml-2">
      <p *ngFor="let typeDisplay of productTypeDisplays">
        <b>{{ typeDisplay }}</b>
      </p>

      <p *ngIf="!!baseProject?.hasSecondBoard" class="secondary-color">
        + tweede bord
      </p>
    </div>
  </div>

  <div *ngIf="originalPlacementDate != null" class="pop-up-padding-first">
    <p>
      Geplaatst op:
      <b>{{ originalPlacementDate | formatDate }}</b>
      - {{ baseProject?.clientCornerPlacerNames }}
    </p>
  </div>

  <ng-container
    *ngIf="
      latestSubProject?.clientDisplayStatus === 'Nieuw' ||
      latestSubProject?.clientDisplayStatus === 'In behandeling'
    "
  >
    <hr />

    <div class="d-flex pop-up-padding-first pb-3">
      <div class="mr-3">
        <button
          style="margin-bottom: 10px"
          class="rounded scale-button"
          [class.request-repo]="latestSubProject?.type === 'Repo'"
          [class.request-adjustment]="latestSubProject?.type === 'Adjustment'"
          [class.request-sold-rented]="latestSubProject?.type === 'SoldRented'"
          [class.request-base]="latestSubProject?.type === 'BaseProject'"
          [disabled]="true"
        >
          <mat-icon
            *ngIf="latestSubProject?.type === 'Repo'"
            svgIcon="client-arrow"
          ></mat-icon>

          <mat-icon
            *ngIf="latestSubProject?.type === 'Adjustment'"
            svgIcon="client-gear"
          ></mat-icon>

          <mat-icon
            *ngIf="latestSubProject?.type === 'SoldRented'"
            svgIcon="client-arrow"
          ></mat-icon>

          <span
            *ngIf="latestSubProject?.type === 'BaseProject'"
            class="font-weight-bold ft-21 m-auto p-1 pl-2"
          >
            IP
          </span>
        </button>
      </div>

      <div>
        <p
          *ngIf="latestSubProject?.type === 'Repo'"
          class="font-weight-bold ft-18 mt-1"
        >
          Weghalen
        </p>

        <p
          *ngIf="latestSubProject?.type === 'SoldRented'"
          class="font-weight-bold ft-18 mt-1"
        >
          '{{ latestSubProject?.stickerText }}' aanbrengen
        </p>

        <p
          *ngIf="latestSubProject?.type === 'Adjustment'"
          class="font-weight-bold ft-18 mt-1"
        >
          Aanpassing
        </p>

        <p
          *ngIf="latestSubProject?.type === 'BaseProject'"
          class="font-weight-bold ft-18 mt-1"
        >
          {{
            latestSubProject?.clientDisplayStatus !== 'Nieuw' &&
            latestSubProject?.clientDisplayStatus !== 'In behandeling'
              ? 'Geplaatst'
              : 'Te plaatsen'
          }}
        </p>

        <p *ngIf="latestSubProject?.currentCreatedAt">
          Aanvraagdatum:
          {{ latestSubProject.currentCreatedAt | date : 'dd/MM/yyy' }}
        </p>

        <p class="mb-0">
          Aangevraagd door:
          {{
            latestSubProject?.projectUser?.firstName
              | personName : latestSubProject?.projectUser?.lastName
          }}
        </p>

        <p>
          Gewenste datum:
          {{
            latestSubProject?.projectPlacement?.placementEarliestDate
              | formatASAPDate : latestSubProject?.projectPlacement?.placeASAP
          }}
        </p>

        <p class="mb-0">
          Vermoedelijke uitvoerdatum:
          <span class="red-accent">
            {{ tentativeExecutionDate | formatDate }}
          </span>
        </p>

        <p>Installateur: {{ latestSubProject?.clientCornerPlacerNames }}</p>
      </div>

      <div class="ml-auto pr-2">
        <a *ngIf="mailContent?.length > 0" href="{{ mailContent }}">
          <mat-icon class="icon-xxl">mail</mat-icon>
        </a>
      </div>
    </div>
  </ng-container>

  <ng-container
    *ngIf="latestSubProject?.type !== 'Repo' && canRequestAdjustment"
  >
    <hr />

    <div class="pop-up-padding-first">
      <div class="d-flex">
        <div [matTooltip]="'Aanpassing aanvragen'">
          <button
            class="clickable rounded scale-button request-adjustment"
            (click)="requestAdjustment()"
          >
            <mat-icon svgIcon="client-gear"></mat-icon>
          </button>
        </div>

        <p
          class="action-button-text active-action-button-text"
          (click)="requestAdjustment()"
        >
          {{ adjustmentButtonLabel }}
        </p>
      </div>
    </div>

    <div class="pop-up-padding">
      <div class="d-flex">
        <div [matTooltip]="'Verkocht/Verhuurd aanvragen'">
          <button
            class="clickable rounded scale-button request-sold-rented"
            (click)="requestSoldRented()"
          >
            <mat-icon svgIcon="client-check"></mat-icon>
          </button>
        </div>

        <p
          class="action-button-text active-action-button-text"
          (click)="requestSoldRented()"
        >
          {{ soldRentedButtonLabel }}
        </p>
      </div>
    </div>

    <div class="pop-up-padding">
      <div class="d-flex">
        <div [matTooltip]="'Weghalen aanvragen'">
          <button
            style="margin-bottom: 10px"
            class="clickable rounded scale-button request-repo"
            (click)="requestRepo()"
          >
            <mat-icon svgIcon="client-arrow"></mat-icon>
          </button>
        </div>

        <p
          class="action-button-text active-action-button-text"
          (click)="requestRepo()"
        >
          {{ repoButtonLabel }}
        </p>
      </div>
    </div>
  </ng-container>
</div>
